export default "__VITE_PUBLIC_ASSET__e6b98f49__"